module.exports = __webpack_public_path__ + "img/cszq_banner_1.ebeca126.png";